<template>
  <div class="main-container">
    <div class="main-container-title-box">
      <div class="main-container-title-box-text">
        <span> Документы </span>
      </div>
      <v-btn
        @click="goToEdit"
        style="width: auto !important"
        class="button-action-blue"
      >
        Редактировать
      </v-btn>
    </div>
    <div
      class="d-flex align-center main-container-info-box"
      style="margin: 0 24px 40px 24px"
    >
      <v-switch
        @change="showInApp"
        v-model="showBlock"
        hide-details
        color="var(--app-green-1)"
      ></v-switch>
      <span>Отображать раздел</span>
    </div>

    <div class="main-container-info-box">
      <div class="info-block" v-if="document.text">
        <div class="info-block-title">Основной текст</div>
        <div class="info-block-text">
          {{ document.text }}
        </div>
      </div>
      <div class="info-block">
        <div class="info-block-title">
          {{ files.length > 1 ? "Вложенные файлы" : "Вложенный файл" }}
        </div>
        <div class="container-box-text">
          Добавьте документы необходимые для выборов в формате PDF
        </div>
        <div class="info-block-text">
          <div v-for="(i, index) in files" :key="index">
            <v-icon> mdi-file-pdf-box </v-icon>
            <a style="margin-left: 8px" target="_blank" :href="i.url">{{
              i.name
            }}</a>
          </div>
        </div>
      </div>

      <div class="info-block image-container" v-if="document.image">
        <div class="info-block-title">Изображение</div>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Формат</th>
                <th class="text-left">Место отображенния</th>
                <th class="text-left">Для смартфонов</th>
                <th class="text-left">Для планшетов</th>
              </tr>
            </thead>
            <tbody>
              <tr style="height: 60px">
                <td class="text-left">Иконка раздела</td>
                <td class="text-left">Изображение на фоне раздела</td>
                <td class="text-left">
                  <img
                    @click="openDialogImg(document.imageMobile)"
                    v-if="document.imageMobile"
                    class="table-img"
                    :src="document.imageMobile"
                  />
                </td>
                <td class="text-left">
                  <img
                    @click="openDialogImg(document.imageTablet)"
                    v-if="document.imageTablet"
                    class="table-img"
                    :src="document.imageTablet"
                  />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({
    showInfo: false,
    x: null,
    y: null,
    document: {},
    files: [],
    imageWidth: 0,
    newImage: null,

    showBlock: null,

    photo: {
      image: null,
      imageMobile: null,
      imageTablet: null,
    },
  }),
  methods: {
    goToEdit() {
      this.$emit("goToEdit");
    },

    showInApp() {
      const documentsBody = {
        showBlock: this.showBlock,
      };
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV5 +
            "/ksa-election-blocks/election-documents/visibility",
          documentsBody,
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then(() => {
          this.$store.commit("errorSet", {
            key: true,
            text: "Статус успешно изменен",
            type: "success",
          });
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },

    getDocuments() {
      this.$axios
        .get(
          this.$store.getters.apiAdminPanelV5 +
            "/ksa-election-blocks/election-documents",
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then((res) => {
          this.document = res.data.documents;
          this.showBlock = res.data.documents.showBlock;
          this.files = res.data.files;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
  },
  created() {
    this.getDocuments();
  },
};
</script>
<style lang="scss" scoped>
.main-container {
  .main-container-title-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 40px 24px;

    .main-container-title-box-text {
      display: flex;
      align-items: center;

      span {
        font-size: 28px;
        font-weight: 400;
        margin-right: 20px;
      }
    }
  }

  .main-container-info-box {
    .table-title {
      font-size: 24px;
      font-weight: 600;
      margin: 0 24px;
    }

    .info-block {
      width: 50%;
      margin: 0 24px;
      margin-bottom: 50px;

      .info-block-title {
        font-size: 24px;
        font-weight: 600;
      }

      .container-box-text {
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
        color: var(--app-dark-grey-1);
        margin-bottom: 16px;
      }

      .info-block-text {
        font-size: 18px;
        font-weight: 400;
      }
    }

    .image-container {
      max-width: 1200px;
      width: 90%;
      margin: 0 24px;
      margin-bottom: 50px;
    }

    .table-img {
      cursor: pointer;
      height: 38px;
      object-fit: contain;
    }
  }
}
</style>
